
import yuklerListesiDark from "../../../../images/svg/colors/dark/yukler-listesi-dark.svg"
import atananlarDark from "../../../../images/svg/colors/dark/surucu-onayinda-dark.svg"
import yuklemedeDark from "../../../../images/svg/colors/dark/yuklemede-dark.svg"
import seferdeDark from "../../../../images/svg/colors/dark/seferde-dark.svg"
import bosaltmadaDark from "../../../../images/svg/colors/dark/bosaltmada-dark.svg"
import tamamlananSeferlerDark from "../../../../images/svg/colors/dark/tamamlanan-seferler-dark.svg"

import yuklerListesiLight from "../../../../images/svg/colors/light/yukler-listesi-light.svg"
import atananlarLight from "../../../../images/svg/colors/light/surucu-onayinda-light.svg"
import yuklemedeLight from "../../../../images/svg/colors/light/yuklemede-light.svg"
import seferdeLight from "../../../../images/svg/colors/light/seferde-light.svg"
import bosaltmadaLight from "../../../../images/svg/colors/light/bosaltmada-light.svg"
import tamamlananSeferlerLight from "../../../../images/svg/colors/light/tamamlanan-seferler-light.svg"

import TopbarMenuItem from "./TopbarMenuItem"
import styled from "styled-components"
import { useSelector } from "react-redux"

const Container = styled.div`
  width: 100%;
  height: 110px;
  border: 1px solid ${({ theme }) => theme.mainBorderColor};
  display: flex;
  align-items: center;

    .wrapper{
        width: calc(100% - 60px);
        margin: 0 30px;
        display: flex;
        height: 100%;
        justify-content: space-between;
        align-items: center;
        position: relative;
    }
    .active-arrow{
        transform: rotate(180deg);
        top: 0px !important;
        right: -24px !important;
    }
    .arrow{
        position: absolute;
        top: 77px;
        right: -68px;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        margin-right: 45px;
        padding: 5px;
        border-radius: 8px;
        background-color: var(--color-light);
        cursor: pointer;
    }
    @media (max-width: 1550px) {
        right: -40px;
        
        svg{
            width: 10px;
            height: 10px;
            color: var(--color-dark);
   }
    }
`

const TopbarMenuler = () => {
    const {topPagesNotificationsCounts, topPagesCounts} = useSelector(state => state.notification)
    const {atananlarListQuantity} = useSelector(state => state.loadList)

    const items = [
        {
            id:0,
            text:"Yük Ekle",
            path: "/yuk-ekle",
            isShRl: false
        },
        {
            id:1,
            text:"Yükler Listesi",
            smText: "Yükler",
            path: "/yukler-listesi",
            imgDark:yuklerListesiDark,
            imgLight: yuklerListesiLight,
            quantity: topPagesCounts?.yukListesiSayisi,
            //   notifications: null
            isShRl: false
        },
        {
            id:2,
            text:"Atananlar",
            smText: "Atananlar",
            imgDark:atananlarDark,
            imgLight: atananlarLight,
            path: "/atananlar",
            quantity: atananlarListQuantity ?? topPagesCounts?.shipmentAtananSayisi ?? topPagesCounts?.atananlarSayisi ?? topPagesCounts?.surucuOnayındakiTeklifSayisi ?? 0,
            notifications: topPagesNotificationsCounts?.driverApprovedAspire,
            isShRl: false
        },
        {
            id:4,
            text:"Yüklemede",
            smText: "Yüklemede",
            imgDark:yuklemedeDark,
            imgLight: yuklemedeLight,
            path: "/yuklemede",
            quantity: topPagesCounts?.shipmentYuklemedeSayisi,
            notifications: topPagesNotificationsCounts?.onLoad,
            isShRl: false
        },
        {
            id:5,
            text:"Seferde",
            smText: "Seferde",
            imgDark:seferdeDark,
            imgLight: seferdeLight,
            path: "/seferde",
            quantity: topPagesCounts?.shipmentSeferdeSayisi,
            notifications: topPagesNotificationsCounts?.onShipment,
            isShRl: false
        },
        {
            id:6,
            text:"Boşaltmada",
            smText: "Boşaltmada",
            imgDark:bosaltmadaDark,
            imgLight: bosaltmadaLight,
            path: "/bosaltmada",
            quantity: topPagesCounts?.shipmentBoşaltmadaSayisi,
            notifications: topPagesNotificationsCounts?.onUnload,
            isShRl: false
        },
        {
            id:7,
            text:"Tamamlanan Seferler",
            smText: "Tamamlanan",
            imgDark:tamamlananSeferlerDark,
            imgLight: tamamlananSeferlerLight,
            path: "/tamamlanan-seferler",
            quantity: topPagesCounts?.shipmentTamamlanananSayisi,
            notifications: topPagesNotificationsCounts?.shipmentCompleted,
            isShRl: false
        },
    ]

  return (
    <Container >
    <div className="wrapper">
        {items.map((item)=> (
            <TopbarMenuItem key={item.id} item={item}/>
        ))}
    </div>
</Container>
  )
}

export default TopbarMenuler
